import { Route, Routes } from "react-router-dom";
import AdminDashboard from "../../pages/AdminDashboard";
import AdminUsers from "../../pages/AdminUsers";
import AdminUserDetail from "../../pages/AdminUserDetail";
import AdminPayins from "../../pages/AdminPayins";
import AdminPayouts from "../../pages/AdminPayouts";
import ProtectedLayout from "../../layouts/ProtectedLayout";
import AdminCommissions from "../../pages/AdminCommissions";
import AdminGateways from "../../pages/AdminGateways";
import AdminBillers from "../../pages/AdminBillers";
import AdminPendingBills from "../../pages/AdminPendingBills";
import AdminMenuAccess from "../../pages/AdminMenuAccess";
import AdminPayoutCharges from "../../pages/AdminPayoutCharges";
import AdminApprovals from "../../pages/AdminApprovals";
import AdminReports from "../../pages/AdminReports";
import AdminUserPassbook from "../../pages/AdminUserPassbook";
import AdminSiteTiming from "../../pages/AdminSiteTiming";
import AdminPaymentPoints from "../../pages/AdminPaymentPoints";
import AdminOfflineCollections from "../../pages/AdminOfflineCollections";

export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<ProtectedLayout allowedRoles={["ADMIN"]} />}>
        <Route path="dashboard" element={<AdminDashboard />} />
        <Route path="reports" element={<AdminReports />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="users/:id" element={<AdminUserDetail />} />
        <Route path="users/:id/passbook" element={<AdminUserPassbook />} />
        <Route path="approvals" element={<AdminApprovals />} />
        <Route path="payins" element={<AdminPayins />} />
        <Route path="payouts" element={<AdminPayouts />} />
        <Route path="commissions" element={<AdminCommissions />} />
        <Route path="gateways" element={<AdminGateways />} />
        <Route path="billers" element={<AdminBillers />} />
        <Route path="pending-bills" element={<AdminPendingBills />} />
        <Route path="menu-access" element={<AdminMenuAccess />} />
        <Route path="payout-charges" element={<AdminPayoutCharges />} />
        <Route path="site-timing" element={<AdminSiteTiming />} />
        <Route path="payment-points" element={<AdminPaymentPoints />} />
        <Route path="offline-collections" element={<AdminOfflineCollections />} />
      </Route>
    </Routes>
  );
}
